import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import HelpPage from './pages/Help';
import { UserProvider } from './UserContext';
import { getCookie, isTokenExpired } from './conf/config';

console.log("=== ENV VARS ===");
console.log("REACT_APP_API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);
console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("===================");
console.log("=== INNOCOSO REACT RUNTIME LOG START ===");
console.log("REACT_APP_API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);
console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("window.origin:", window.origin);
console.log("window.location.href:", window.location.href);
console.log("window.location.hostname:", window.location.hostname);
console.log("window.location.pathname:", window.location.pathname);
console.log("window.location.search:", window.location.search);
console.log("=== INNOCOSO REACT RUNTIME LOG END ===");


const root = ReactDOM.createRoot(document.getElementById('root'));

// The help window is a standalone popup — it has no need for UserProvider (no
// API calls, no auth state, no orders). Rendering it directly here prevents
// UserProvider's refreshOrders() from triggering a window.location.href redirect
// that would silently navigate the help window away from /help.
if (window.location.pathname === '/help') {
  const token = getCookie('access_token');
  const authed = !!(token && !isTokenExpired(token));
  root.render(
    <React.StrictMode>
      {authed
        ? <HelpPage />
        : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#999', fontFamily: 'sans-serif', fontSize: 15 }}>
            Please log in to access help.
          </div>
      }
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <UserProvider>
        <App />
      </UserProvider>
    </React.StrictMode>
  );
}

